<div fxLayout="column" id="footer" class="m-b-20">
  <mat-divider fxFlexAlign="center" class="divider"></mat-divider>
  <p fxFlexAlign="center" class="footer-content">{{ version }}</p>
  <p fxFlexAlign="center" class="footer-content">Fecha de lanzamiento 02/April/2021</p>
</div>
